import {
    CUSTOM_ELEMENTS_SCHEMA,
    inject,
    NgModule,
    NO_ERRORS_SCHEMA,
    provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { FeatureModule } from 'src/modules/features/module';
import { NotificationModule } from 'src/modules/notifications/module';
import { OrderApiService } from 'src/modules/order/services/order-api-service';
import { AdminModule } from 'src/modules/role/admin/module';
import { AllAdminUsersAdminModule } from 'src/modules/role/all-admin-users/module';
import { EventAdminModule } from 'src/modules/role/event-admin/module';
import { FinanceAdminModule } from 'src/modules/role/finance-admin/module';
import { ListingAdminModule } from 'src/modules/role/listing-admin/module';
import { OrganisationAdminModule } from 'src/modules/role/organisation-admin/module';
import { RetiredUsersAdminModule } from 'src/modules/role/retired-user-admin/module';
import { UserAdminModule } from 'src/modules/role/user-admin/module';
import { ProductDataSource } from '../modules/product/services/product-data-source';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CallbackComponent } from './components/callback/callback.component';
import { Dashboard } from './components/dashboard/component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { LoggedInGuard } from './guards/logged-in.guard';
import { LoggedOutGuard } from './guards/logged-out.guard';
import { MaterialModule } from './material.module';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { CommonFunctionService } from './services/common-function.service';
import { ImagesService } from './services/images.service';
import { LoginService } from './services/login.service';

export function tokenGetter() {
  return localStorage.getItem('partnerchoice_authentication');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    Dashboard,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    CallbackComponent,
    FormsModule,
    ReactiveFormsModule,
    AdminModule,
    UserAdminModule,
    EventAdminModule,
    ListingAdminModule,
    AllAdminUsersAdminModule,
    RetiredUsersAdminModule,
    OrganisationAdminModule,
    FeatureModule,
    NotificationModule,
    FinanceAdminModule,
    JwtModule.forRoot({
      config: { tokenGetter: tokenGetter },
    }),
  ],
  providers: [
    AuthService,
    LoggedInGuard,
    LoggedOutGuard,
    LoginService,
    ApiService,
    CommonFunctionService,
    OrderApiService,
    ProductDataSource,
    ImagesService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    provideAppInitializer(() => inject(AuthService).configInit()),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
